import BaseAPI from "@/api/BaseAPI";

export class FormA_G_API extends BaseAPI {
  constructor() {
    super('');
  }

  read2(id, part, full = false) {
    return this.http.get(`/forms/${part}/get?orgId=${id}&${full}`)
  }
}

export default new FormA_G_API()